import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

const ProfileHeader = ({ firstName }) => {
  return (
    <>
      <div
        className="header pb-6 d-flex align-items-center"
        style={{
          minHeight: "260px"
        }}
      >
        <span className="mask bg-gradient-info" />

        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="12" md="12">
              <h1 className="display-2 text-white">Hello {firstName}</h1>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default ProfileHeader;
